import type { Shader, ShaderInput } from "../types";

const BASE = "/api";

async function req<T>(path: string, init?: RequestInit): Promise<T> {
  const r = await fetch(BASE + path, {
    credentials: "include",
    ...init,
    headers: {
      "Content-Type": "application/json",
      ...(init?.headers ?? {}),
    },
  });
  if (!r.ok) throw new Error(`${r.status} ${await r.text()}`);
  return r.json() as Promise<T>;
}

export const api = {
  list: () => req<Shader[]>("/shaders"),
  get: (id: string) => req<Shader>(`/shaders/${encodeURIComponent(id)}`),
  create: (s: ShaderInput) =>
    req<Shader>("/admin/shaders", { method: "POST", body: JSON.stringify(s) }),
  update: (id: string, s: ShaderInput) =>
    req<Shader>(`/admin/shaders/${encodeURIComponent(id)}`, {
      method: "PUT",
      body: JSON.stringify(s),
    }),
  remove: (id: string) =>
    req<{ ok: true }>(`/admin/shaders/${encodeURIComponent(id)}`, { method: "DELETE" }),
};

// Silent auth probe — Access redirects unauthenticated browser requests, but
// fetch() with `redirect: "manual"` surfaces that as an opaque-redirect or
// non-2xx response. Treat anything other than a 200 JSON body as "not owner".
export async function probeOwner(): Promise<string | null> {
  try {
    const r = await fetch(BASE + "/admin/whoami", {
      credentials: "include",
      redirect: "manual",
    });
    if (!r.ok || r.type === "opaqueredirect") return null;
    const data = (await r.json()) as { email: string | null };
    return data.email;
  } catch {
    return null;
  }
}
